module.exports = __webpack_public_path__ + "img/FloatingFooter.2effd058.png";